// import api from "../../../api/api";

import api from "./api";

/**
 * 
 * @param phone_number 
 * @param password 
 * @returns 
 */
const login = (phone_number, password) => {

    const data = {
        "phone_number": phone_number,
        "password": password,
        "app_key": "AIzaSyCxuwA-_cqYu2J82664iF6bjFv-xAWNEjE"
    };
    return api.post('/signin', data);
};

/**
 * 
 * @returns 
 */
const logout = (token) => {
    return api.post('/signout', undefined, { headers : { Authorization : `Bearer ${token}` } });
};

/**
 * 
 */
const AUTH = {
    login,
    logout
};

export default AUTH;
